// src/pages/NotFound.js
import React from 'react';
import './NotFound.css'; // Import the CSS file for styling

const NotFound = () => {
    return (
        <div className="not-found-container">
            <div className="not-found-title">
                <h1 className="glitch" data-text="404">404</h1>
                <p className="glitch" data-text="Page Not Found">Page Not Found</p>
            </div>
            <div className="animation-area">
                <ul className="box-area">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            </div>
            <div className="back-home">
                <a href="/" className="home-link">Go Back Home</a>
            </div>
        </div>
    );
};

export default NotFound;
